import { render, staticRenderFns } from "./TestApi.vue?vue&type=template&id=2a07ec7b&scoped=true&"
import script from "./TestApi.vue?vue&type=script&lang=js&"
export * from "./TestApi.vue?vue&type=script&lang=js&"
import style0 from "./TestApi.vue?vue&type=style&index=0&id=2a07ec7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07ec7b",
  null
  
)

export default component.exports